(() => {
  'use strict';

  const loadVideo = (video, autoplay = false) => {
    if (!video || video.dataset.dsLoaded === 'true') {
      if (autoplay && video?.paused) video.play().catch(() => {});
      return;
    }

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
    }

    video.dataset.dsLoaded = 'true';
    video.load();

    if (autoplay || video.hasAttribute('data-ds-autoplay')) {
      const play = () => video.play().catch(() => {});
      if (video.readyState >= 2) play();
      else video.addEventListener('loadeddata', play, { once: true });
    }
  };

  const initialise = () => {
    const videos = [...document.querySelectorAll('video[data-ds-lazy-video]')];
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target, entry.target.hasAttribute('data-ds-autoplay'));
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '400px 0px' });

      videos.forEach((video) => observer.observe(video));
    } else {
      videos.forEach((video) => loadVideo(video, video.hasAttribute('data-ds-autoplay')));
    }

    document.addEventListener('click', (event) => {
      const video = event.target.closest('[data-ds-video-trigger]')?.querySelector('video[data-ds-lazy-video]');
      if (video) loadVideo(video, true);
    }, true);
  };

  window.DailyShakePerformance = { loadVideo };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
